import Endpoint from "@/utils/endPoint";

const externalsEndpoint = new Endpoint("/external_docs/");
const externalEndpoint = new Endpoint("/external_docs/{id}");

class ExternalService {
    async getExternalListService(params) {
        const result = await externalsEndpoint.get(params);
        return result;
    }
    async getExternalService(params) {
        const result = await externalEndpoint.get(params);
        return result;
    }
    async createExternalService(params) {
        const result = await externalsEndpoint.post(params);
        return result;
    }
    async delExternalService(params) {
        const result = await externalEndpoint.del(null, params);
        return result;
    }
    async updateExternalService(params) {
        const { id, ...param } = params;
        const result = await externalEndpoint.put(param, { id });
        return result;
    }
}

export default new ExternalService();
